// The initial redux state values
export const initialState = { 
                            'language': 'FR',
                            'carouselCurrentImage' : 0,
                            'carouselCurrentProject' : 0,
                            'carouselNbOfImages' : 2}
//Declaring all text values for the interface as a litteral object:

export const FrontPageLabels = { labels : 
    {
    title       : { 'FR' : "Développeur Front-End",
                    'EN' : "Front-End developer"},
    catchPhrase : { 'FR' : "",
                    'EN' : "My stack is so fiiiiiine"},

    }
}

export const HeaderLabels = { labels : 
    {
    title       : { 'FR' : "Clement Benezech",
                    'EN' : "Clement Benezech"}

    }
}

export const WhatIDoLabels = { labels : 
    {
    '1'       : {  'FR' : "Je me concentre principalement sur React et son écosystème, react-router, Redux... :)",
                 'EN' : "I'm a front end developer with a strong focus on React and redux based apps"},
    '2'        : { 'FR' : "N'hésitez pas à visiter ma galerie de projets, et à consulter les sources sur Github",
                 'EN' : "I like creating beautiful responsive UI with functional components and hooks"},
    '3'        : { 'FR' : "Je suis ouvert aux opportunités de travail en freelance",
                 'EN' : "I'm open to freelance work opportunities"},            

    }
}

export const FavoriteTools = {'FR' : 'Mes outils favoris!', 'EN': 'My favourite tools!'}

export const readMyBlog = {'FR' : 'Vous voulez lire mon blog? Il est sur', 'EN': "Want to read my blog? It's on"}

export const MyProjects = {'FR' : 'Une selection de mes projets', 'EN': "Some of my projects"}

export const PreviousNext = {   'previous' : {'FR' : 'précédent', 'EN': "previous"},
                                'next' : {'FR' : 'suivant', 'EN': "next"}
                            }

export const gitHubRepositoryLabel = {'FR' : 'Repository sur github:', 'EN': "Github Repository:"}
export const webPageLabel = {'FR' : 'Visiter le site:', 'EN': "Visit the website:"}

export const languagesLabels = {   'FR' : {'FR' : 'Français (Natif)', 'EN': "French (Native)"},
'EN' : {'FR' : 'Anglais (Bilingue)', 'EN': "English (Fluent)"}
}


export const skills = [
    {   'id' : 0,
        'name' : 'HTML 5',
        'description' : 'Clean, accessible && W3C compliant',
        'price' : 300,
        'image' : "html5"
    },
    {   'id' : 1,
        'name' : 'Css / Sass',
        'description' : 'Clean and nested Scss stylesheets. BEM style.',
        'price' : 400,
        'image' : "sass"
    },
    {   'id' : 2,
        'name' : 'Vanilla JS',
        'description' : 'Mmmmhhh, Vanilla... No. seriously.',
        'price' : 500,
        'image' : "jsvanilla"
    },
    {   'id' : 3,
        'name' : 'Typescript',
        'description' : "",
        'price' : 200,
        'image' : "typescript"
    },
    {   'id' : 4,
        'name' : 'ReactJS',
        'description' : "Functional style. It's all about the hooks!",
        'price' : 600,
        'image' : "react"
    },
    {   'id' : 5,
        'name' : 'Redux',
        'description' : 'In the states, they reduced the stores',
        'price' : 300,
        'image' : "redux"
    },
    {   'id' : 6,
        'name' : 'React Router',
        'description' : "So you know where you're going",
        'price' : 200,
        'image' : "react-router"
    },
    {   'id' : 7,
        'name' : 'Styled Components',
        'description' : "",
        'price' : 200,
        'image' : "styled-components"
    }
    


]

export const projects = [
    {   'id' : 1,
        'name' : 'React Weather App',
        'description' : {'FR': "Un site de prévision météo, basé sur les données de l'API OpenWeatherApp",
                    'EN' : "A weather forecast application based on OpenweatherApp API"},
        'folder': "weatherApp",
        "nbOfImages" : 3,
        'techs' : ["react", "redux", "sass"],
        'webPage' : 'https://clementbenezech.github.io/react-meteo-app/',
        'repo' : 'https://github.com/ClementBenezech/meteo-app'
    },
    {   'id' : 2,
        'name' : 'React Shopping Cart',
        'description' : {'FR': "Un composant de type 'shopping cart' réalisé avec React et Redux",
                        'EN' : "A cool simple shopping cart made with React and Redux"},
        'folder': "shoppingCart",
        "nbOfImages" : 3,
        'techs' : ["react", "redux", "sass", "react-router"],
        'repo' : 'https://github.com/ClementBenezech/shopping-cart',
        'webPage' : 'https://clementbenezech.github.io/react-shopping-cart/#/'
    },
    {   'id' : 3,
        'name' : 'Wingman Parachutisme',
        'description' : {'FR': "Un site vitrine pour une école de parachutisme, multilingue, réalisé avec React ",
                        'EN' : "A skydiving school website, with multilingual support!"},
        'folder': "wingman",
        "nbOfImages" : 4,
        'techs' : ["react", "redux", "sass", "react-router"],
        'webPage' : 'https://wingmanparachutisme.com/'
        
    },
    {   'id' : 4,
        'name' : 'Fish Eye',
        'description' : {'FR': "Un site en VanillaJS et SCSS, qui présente des photos d'artistes",
                        'EN' : "Vanilla JS / SASS based website displaying photo galleries for artists"},
        'folder': "fisheye",
        "nbOfImages" : 5,
        'techs' : [ "sass", "jsvanilla"],
        'repo' : "https://github.com/ClementBenezech/ClementBenezech_6_19052021",
        'webPage' : 'https://clementbenezech.github.io/ClementBenezech_6_19052021/'
    },
    {   'id' : 5,
        'name' : 'Les petits plats',
        'description' : {'FR': "Un moteur de recherche en JS avec filtres avancés et résultats instantanés",
                        'EN' : "Made with vanilla JS, this site provides instant search results and advanced filters"},
        'folder': "lesPetitsPlats",
        "nbOfImages" : 3,
        'techs' : [ "sass", "jsvanilla"],
        'repo' : "https://github.com/ClementBenezech/clementbenezech_7_14072021",
        'webPage' : 'https://clementbenezech.github.io/clementbenezech_7_14072021/'
    },
    {   'id' : 6,
        'name' : 'React Game Experiment',
        'description' : {'FR': "Un clone de space invaders créé from scratch avec React et Redux! Essayez le :) (Desktop uniquement) ",
                        'EN' : "A clone of space invaders made with React and Redux. No external libraries. Try it :) (Desktop Only)"},
        'folder': "gameExperiment",
        "nbOfImages" : 4,
        'techs' : [ "sass", "react", "redux"],
        'repo' : "https://github.com/ClementBenezech/the-react-game-experiment",
        'webPage' : 'https://clementbenezech.github.io/grid-experiment/'
    },
    {   'id' : 7,
        'name' : 'Kasa',
        'description' : {'FR': "Un prototype de site type AirBnB, réalisé avec des class components, uniquement avec React et react-router",
                        'EN' : "A airBnB clone prototype created using React with class components and react-router only"},
        'folder': "kasa",
        "nbOfImages" : 4,
        'techs' : [ "sass", "react", "react-router"],
        'repo' : "https://github.com/ClementBenezech/clementbenezech_11_19112021/tree/V2",
        'webPage' : 'https://kasabuild.netlify.app/'
    },
    {   'id' : 8,
        'name' : 'SportSee',
        'description' : {'FR': "Un tableau de bord pour une application de sport, basé sur React/TypeScript/Styled-components/Rechart",
                        'EN' : "A Dashboard page for a Sports app, built with React and Typescript, using Styled components and Rechart"},
        'folder': "sportsee",
        "nbOfImages" : 3,
        'techs' : [ "styled-components", "react", "typescript"],
        'repo' : "https://github.com/ClementBenezech/sports-analytics-dashboard"
    },
    {   'id' : 9,
        'name' : 'Task Tracker',
        'description' : {'FR': "Une application de gestion des tâches, responsive, basée sur React Redux et SASS",
                        'EN' : "A simple and responsive task manager based on React, Redux, and SASS"},
        'folder': "taskTracker",
        "nbOfImages" : 4,
        'techs' : [ "sass", "react", "redux"],
        'repo' : "https://github.com/ClementBenezech/React-task-manager",
        'webPage' : 'https://nice-task-tracker.netlify.app/'
    }

]

/*     {   'id' : 6,
        'name' : 'Native French',
        'description' : "It's like... you know. Super Fluent!",
        'price' : "279",
        'image' : "france"
    },
    {   'id' : 7,
        'name' : 'Fluent english',
        'description' : "For real!",
        'price' : "359",
        'image' : "england"
    }, */